/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AzureApiStrictHttpResponse } from '../../azure-api-strict-http-response';
import { AzureApiRequestBuilder } from '../../azure-api-request-builder';

import { VendorAuctionDetailDto } from '../../models/vendor-auction-detail-dto';
import { VendorAuctionDetailDtoResponseModel } from '../../models/vendor-auction-detail-dto-response-model';

export interface ApiVendorVendorAuctionSubmitPost$Params {

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
      body?: VendorAuctionDetailDto
}

export function apiVendorVendorAuctionSubmitPost(http: HttpClient, rootUrl: string, params?: ApiVendorVendorAuctionSubmitPost$Params, context?: HttpContext): Observable<AzureApiStrictHttpResponse<VendorAuctionDetailDtoResponseModel>> {
  const rb = new AzureApiRequestBuilder(rootUrl, apiVendorVendorAuctionSubmitPost.PATH, 'post');
  if (params) {
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AzureApiStrictHttpResponse<VendorAuctionDetailDtoResponseModel>;
    })
  );
}

apiVendorVendorAuctionSubmitPost.PATH = '/api/vendor/vendor-auction/Submit';
